module.exports = "<div id=\"tb-global-view-ui-root\"\n    ng-if=\"globalViewCtrl.selectedView\">\n    Current View:\n    <span class=\"tb-global-view-info\"\n          uib-tooltip=\"{{globalViewCtrl.selectedView.description}}\" tooltip-popup-delay=\"750\">\n        <a href role=\"button\"\n           aria-label=\"Open global view change menu\"\n           ng-click=\"globalViewCtrl.runChangeViewFlow()\">\n            {{globalViewCtrl.selectedView.friendlyName}}\n        </a>\n    </span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/directives/GlobalViewUi/GlobalViewUi.tpl.html
// module id = 2lne
// module chunks = 1